var _style, _path, _path2, _path3, _circle, _path4, _ellipse, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfettiCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes confetti-cone1{0%{transform:translate(40px,95px) rotate(45deg) scale(1,1)}15%{transform:translate(10px,145px) rotate(45deg) scale(1.1,.85)}to{transform:translate(40px,105px) rotate(45deg) scale(1,1)}}@keyframes confdash{0%,2%{stroke-dasharray:1000;stroke-dashoffset:500;transform:translate(-30px,30px);opacity:0}35%{stroke-dasharray:1000;stroke-dashoffset:900;transform:translate(-2px,0);opacity:1}85%{stroke-dasharray:1000;stroke-dashoffset:1000;transform:translate(1px,-5px);opacity:1}90%{stroke-dashoffset:1000;transform:translate(2px,-8px);opacity:0}to{stroke-dashoffset:500;transform:translate(2px,-8px);opacity:0}}@keyframes confa{0%{opacity:0;transform:translate(-30px,20px) rotate(0)}15%{opacity:1;transform:translate(25px,-10px) rotate(60deg)}80%{opacity:1;transform:translate(33px,-18px) rotate(180deg)}to{opacity:0;transform:translate(37px,-23px) scale(.5) rotate(230deg)}}@keyframes confb{0%{opacity:0;transform:translate(-30px,20px) rotate(0)}12%{opacity:1;transform:translate(25px,-10px) rotate(60deg)}76%{opacity:1;transform:translate(33px,-18px) rotate(180deg)}to{opacity:0;transform:translate(37px,-23px) scale(.5) rotate(240deg)}}@keyframes confc{0%{opacity:.7;transform:translate(-30px,20px) rotate(0)}18%{opacity:1;transform:translate(5px,-10px) rotate(60deg)}76%{opacity:1;transform:translate(13px,-18px) rotate(180deg)}to{opacity:0;transform:translate(17px,-23px) scale(.5) rotate(230deg)}}@keyframes confd{0%{opacity:.7;transform:translate(-20px,20px) rotate(0)}18%{opacity:1;transform:translate(-5px,-10px) rotate(60deg)}76%{opacity:1;transform:translate(-8px,-18px) rotate(180deg)}to{opacity:0;transform:translate(-10px,-23px) scale(.5) rotate(230deg)}}.conf0{fill:#fc6394}.conf2{fill:#5adaea}.conf3{fill:#974cbe}.conf6{fill:#f9b732}#yellow-strip,.conf7,.conf8{fill:none;stroke-miterlimit:10}.conf7{display:none;stroke:#000}#yellow-strip,.conf8{stroke:#f9b732;stroke-width:9;stroke-linecap:round}#yellow-strip{animation:confdash 1.2s ease infinite}\n  ")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "350px 0",
      animation: "confetti-cone1 1.2s ease infinite"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.5 172.6 196 343c2.3 6.1 11 6.1 13.4 0l65.5-170.7-143.4.3z",
    className: "conf0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.5 172.6 196 343c2.3 6.1 11 6.1 13.4 0l6.7-17.5-53.6-152.9h-31z",
    style: {
      fill: "#ef3c8a"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.2 184.2c-1.8 1.8-4.2 2.9-7 2.9l-129.5.4c-5.4 0-9.8-4.4-9.8-9.8s4.4-9.8 9.9-9.9l129.5-.4c5.4 0 9.8 4.4 9.8 9.8-.1 2.8-1.2 5.3-2.9 7z",
    className: "conf2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m231.5 285.4-57.3.1-30.4-80.4 118.9-.4z",
    className: "conf3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m166.3 187.4-28.6.1c-5.4 0-9.8-4.4-9.8-9.8s4.4-9.8 9.9-9.9l24.1-.1s-2.6 5-1.3 10.6c1.2 5.4 5.7 9.1 5.7 9.1z",
    style: {
      fill: "#3cbecd"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 233.9,
    cy: 224,
    r: 5.6,
    className: "conf2",
    transform: "rotate(-45.001 233.948 223.979)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m143.8 205.1 5.4 14.3c6.8-2.1 14.4-.5 19.7 4.8 7.7 7.7 7.6 20.1-.1 27.8-1.7 1.7-3.7 3-5.8 4l11.1 29.4h27.7l-28-80.5-30 .2z",
    style: {
      fill: "#813bbe"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169 224.2c-5.3-5.3-13-6.9-19.7-4.8l13.9 36.7c2.1-1 4.1-2.3 5.8-4 7.6-7.7 7.6-20.2 0-27.9z",
    className: "conf2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.4,
    cy: 254.3,
    className: "conf6",
    rx: 11.3,
    ry: 11.2,
    transform: "rotate(-45.001 207.373 254.326)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 195.2,
    cy: 232.6,
    r: 5.1,
    className: "conf2",
    style: {
      transformOrigin: "195.2px 232.6px",
      animation: "confb 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.8,
    cy: 219.8,
    r: 5.4,
    className: "conf0",
    style: {
      transformOrigin: "230.8px 219.8px",
      animation: "confb 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.9,
    cy: 160.4,
    r: 4.2,
    className: "conf0",
    style: {
      transformOrigin: "178.9px 156.2px",
      animation: "confc 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.8,
    cy: 123.6,
    r: 5.4,
    className: "conf6",
    style: {
      transformOrigin: "133px 118px",
      animation: "confd 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.9,
    cy: 105.1,
    r: 5.4,
    className: "conf0",
    style: {
      transformOrigin: "152px 100px",
      animation: "confd 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.9 176.1-5.7 1.3c-1.6.4-2.2 2.3-1.1 3.5l3.8 4.2c1.1 1.2 3.1.8 3.6-.7l1.9-5.5c.5-1.6-.9-3.2-2.5-2.8z",
    className: "conf0",
    style: {
      transformOrigin: "127px 176px",
      animation: "confd 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.5 170.7-5.4 1.2c-1.5.3-2.1 2.2-1 3.3l3.6 3.9c1 1.1 2.9.8 3.4-.7l1.8-5.2c.5-1.3-.8-2.8-2.4-2.5z",
    className: "conf6",
    style: {
      transformOrigin: "282.3px 170.6px",
      animation: "confb 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.7,
    cy: 144.4,
    r: 4.5,
    className: "conf6",
    style: {
      transformOrigin: "206.7px 140px",
      animation: "confc 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4 192.3h-3.2c-1.6 0-2.9-1.3-2.9-2.9v-3.2c0-1.6 1.3-2.9 2.9-2.9h3.2c1.6 0 2.9 1.3 2.9 2.9v3.2c0 1.6-1.3 2.9-2.9 2.9z",
    className: "conf2",
    style: {
      transformOrigin: "174.8px 183.4px",
      animation: "confc 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.7 197.4h-3.2c-1.6 0-2.9-1.3-2.9-2.9v-3.2c0-1.6 1.3-2.9 2.9-2.9h3.2c1.6 0 2.9 1.3 2.9 2.9v3.2c-.1 1.6-1.4 2.9-2.9 2.9z",
    className: "conf2",
    style: {
      transformOrigin: "262px 188.5px",
      animation: "confb 1.2s ease-out infinite"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "yellow-strip",
    d: "M179.7 102.4s6.6 15.3-2.3 25c-8.9 9.7-24.5 9.7-29.7 15.6-5.2 5.9-.7 18.6 3.7 28.2 4.5 9.7 2.2 23-10.4 28.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.2 156.1s-16.9-3.5-28.8 2.4c-11.9 5.9-14.9 17.8-16.4 29-1.5 11.1-4.3 28.8-31.5 33.4",
    className: "conf8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 254.8h-3.2c-1.6 0-2.9-1.3-2.9-2.9v-3.2c0-1.6 1.3-2.9 2.9-2.9h3.2c1.6 0 2.9 1.3 2.9 2.9v3.2c0 1.6-1.3 2.9-2.9 2.9z",
    className: "conf0",
    style: {
      transformOrigin: "276px 246px",
      animation: "confa 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.2 121.3c.3.6.8 1 1.5 1.1 1.6.2 2.2 2.2 1.1 3.3-.5.4-.7 1.1-.6 1.7.3 1.6-1.4 2.8-2.8 2-.6-.3-1.2-.3-1.8 0-1.4.7-3.1-.5-2.8-2 .1-.6-.1-1.3-.6-1.7-1.1-1.1-.5-3.1 1.1-3.3.6-.1 1.2-.5 1.5-1.1.7-1.5 2.7-1.5 3.4 0z",
    className: "conf3",
    style: {
      transformOrigin: "213.5px 120.2px",
      animation: "confc 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5 191.7c.3.6.8 1 1.5 1.1 1.6.2 2.2 2.2 1.1 3.3-.5.4-.7 1.1-.6 1.7.3 1.6-1.4 2.8-2.8 2-.6-.3-1.2-.3-1.8 0-1.4.7-3.1-.5-2.8-2 .1-.6-.1-1.3-.6-1.7-1.1-1.1-.5-3.1 1.1-3.3.6-.1 1.2-.5 1.5-1.1.6-1.5 2.7-1.5 3.4 0z",
    className: "conf3",
    style: {
      transformOrigin: "222.8px 190.6px",
      animation: "confb 1.2s ease-out infinite"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.6 242.1c.3.6.8 1 1.5 1.1 1.6.2 2.2 2.2 1.1 3.3-.5.4-.7 1.1-.6 1.7.3 1.6-1.4 2.8-2.8 2-.6-.3-1.2-.3-1.8 0-1.4.7-3.1-.5-2.8-2 .1-.6-.1-1.3-.6-1.7-1.1-1.1-.5-3.1 1.1-3.3.6-.1 1.2-.5 1.5-1.1.7-1.5 2.7-1.5 3.4 0z",
    className: "conf3",
    style: {
      transformOrigin: "310.9px 241px",
      animation: "confa 1.2s ease-out infinite"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.7 215.4s-14.4-3.4-22.6 2.7c-8.2 6.2-8.2 23.3-17.1 29.4-8.9 6.2-19.8-2.7-32.2-4.1-12.3-1.4-19.2 5.5-20.5 10.9",
    className: "conf8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiCone);
export default __webpack_public_path__ + "static/media/confetti-cone.5d65cfe1c2048d08fefb8c71583cdf41.svg";
export { ForwardRef as ReactComponent };